<section class="tw-pl-4 tw-py-6 tw-flex tw-flex-col tw-items-stretch tw-gap-3 tw-bg-teal-100">
    <header class="tw-flex tw-items-center tw-justify-between"
            (click)="viewCollection.emit(name())">
        <h2 class="tw-font-lexend tw-font-bold tw-text-500 tw-leading-none">{{title()}}</h2>
        <cs-icon class="tw-w-6 tw-h-6 tw-text-teal-500"
                 [iconName]="'chevron_right'" />
    </header>
    <swiper class="swiper-wrapper" [config]="getSwiperConfig(0)">
        @for (product of products(); track $index) {
            <app-product-jumbo *swiperSlide
                               class="tw-h-full"
                               [product]="product"
                               [productInCart]="getProductCartData(product?.objectId)"
                               (addToCart)="addToCartAction($event)"
                               (reomveFromCart)="removeFromCartAction($event)"
                               (gotoProduct)="gotoProductAction($event)" />
        }
    </swiper>
</section>